import { createSlice } from '@reduxjs/toolkit'
import tcairemService from '../services/tcairemService'
import { setErrorNotification } from './notificationReducer'

const tcairemSlice = createSlice({
    name: 'tcairemResources',
    initialState: { results: null, loading: false },
    reducers: {
        setTcairemResources(state, action) {
            return { results: action.payload, loading: false }
        },
        setLoading(state) {
            return { ...state, loading: true }
        },
        clearTcairemResources(state) {
            return { results: null, loading: false }
        },
    },
})

export const { setTcairemResources, setLoading, clearTcairemResources } = tcairemSlice.actions

export const initializeTcairemResources = () => async (dispatch, getState) => {
    const { results, loading } = getState().tcairemResources
    if (results !== null || loading) return
    dispatch(setLoading())
    try {
        const resources = await tcairemService.retrieveAll()
        dispatch(setTcairemResources(resources))
    } catch (error) {
        dispatch(clearTcairemResources())
        dispatch(setErrorNotification("Failed to load T-CAIREM's resources"))
    }
}

export default tcairemSlice.reducer
